import React from 'react';
import { Link } from 'react-router-dom';

const PremiumFeatureNotice: React.FC = () => (
  <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 px-4">
    <div className="text-center max-w-lg">
      <i className="ph-bold ph-star text-6xl text-primary mb-4"></i>
      <h1 className="text-2xl font-bold text-gray-900 mb-4">
        Fonctionnalité Premium
      </h1>
      <p className="text-gray-600 mb-8">
        La création et la gestion de chapitres personnalisés est une fonctionnalité réservée aux utilisateurs Premium. Passez à la version Premium pour créer vos propres chapitres de formation.
      </p>
      <Link
        to="/subscription"
        className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-primary hover:bg-primary-dark transition duration-150 ease-in-out"
      >
        Passer Premium
        <i className="ph-bold ph-arrow-right ml-2"></i>
      </Link>
    </div>
  </div>
);

export default PremiumFeatureNotice;
